import { DateTime } from 'luxon';

import { lastThirtyDays } from 'app/constants/dates';

import { DataTransferState } from '../types';

export const dataTransferState: DataTransferState = {
  formState: {
    dataTransferOptions: { value: 'FMCSA', label: 'FMCSA' },
    subsetOptions: { value: 'driver', label: 'Driver' },
    selectedDrivers: null,
    selectedVehicles: null,
    dateRange: {
      fromDate:
        (
          DateTime.fromISO(lastThirtyDays.minDate)
            .startOf('day')
            .toISO() as string
        ).substring(23, 0) + 'Z',
      untilDate:
        (
          DateTime.fromISO(lastThirtyDays.maxDate)
            .endOf('day')
            .toISO() as string
        ).substring(23, 0) + 'Z',
    },
    investigationCode: '',
  },
  isToggleSubmitToCcmtaModal: false,
  isToggleFMCSAMessagesPopup: false,
  FMCSAResponse: [],
};
